module.exports = __webpack_public_path__ + "assets/img/53.51f8d116.png";